import { createFileRoute } from '@tanstack/react-router'
import IntegrationContainer from 'Administration/components/system/IntegrationContainer'

import { Guard, adminClaims } from '../-guard'

export const Route = createFileRoute('/administration/integrations')({
    component: () => (
        <Guard claims={adminClaims}>
            <IntegrationContainer />
        </Guard>
    ),
})
